export const FETCH_WEEKS = "FETCH_WEEKS";

export const GENERATE_WEEKS = "GENERATE_WEEKS";


export const DELETE_WEEK = "DELETE_WEEK";

export const EDIT_WEEK_INFO = "EDIT_WEEK_INFO";
